export default __webpack_public_path__ + "static/media/Align-Items.d5298ed7.jpeg";